<template>
  <a 
    :class="{
    'cursor-default': props.href === '#'
    }" 
    :href="props.href" 
    :target="props.target" 
    :title="props.title"
    rel="noopener noreferrer nofollow" 
    @click="emit('click')">
    <slot />
  </a>
</template>

<script lang="ts" setup>
const props = defineProps({
  href: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  target: {
    type: String,
    default: '_blank',
  },
})

const emit = defineEmits(['click'])
</script>
